module.exports = __webpack_public_path__ + "img/goodsB3.e67ddaac.png";